// ─── Default Account Manager — Ryan Young ───
// Used as the system fallback when a client has no explicit `crm.assignedTo`.
// Backed by a real user record seeded on the backend (see `_seed_default_account_manager`
// in /app/backend/server.py). The id below MUST match the seeded user._id.

export const DEFAULT_ACCOUNT_MANAGER = {
  id: 'user-default-am-ryan-young',
  email: 'r.young@healthcues.com',
  firstName: 'Ryan',
  lastName: 'Young',
  fullName: 'Ryan Young',
  title: 'Account Manager',
  phone: '949.290.1979',
  role: 'account_manager',
};

// Resolve the AM display info for a client. Falls back to Ryan Young when no
// AM is assigned. Pass an optional users list to resolve real user records by id.
export function resolveAccountManager(client, users = []) {
  const assignedId = client?.crm?.assignedTo;
  if (assignedId) {
    const u = users.find((x) => x.id === assignedId || x._id === assignedId);
    if (u) {
      return {
        id: u.id || u._id,
        firstName: u.firstName || '',
        lastName: u.lastName || '',
        fullName: `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.email || 'Account Manager',
        email: u.email || '',
        phone: u.phone || '',
        title: u.title || 'Account Manager',
        isDefault: false,
      };
    }
  }
  return { ...DEFAULT_ACCOUNT_MANAGER, isDefault: true };
}
